export default () => (document.getElementById("loader").style.display = "none");
